"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.runRequests = runRequests;
const SharedTypes = __importStar(require("../nevada-shared/types"));
const SharedTools = __importStar(require("../nevada-shared/functions"));
const GraphQlRequest = __importStar(require("@genesys/graphql-request"));
const queries_1 = require("./queries");
async function runRequests(systemTestRow, graphqlEndpoint, authorization, getFormat, update) {
    let updatedSystem = Object.assign({}, systemTestRow);
    try {
        updatedSystem = Object.assign(Object.assign({}, systemTestRow), { status: SharedTypes.Status.FetchingRefSystem });
        update(updatedSystem);
        const referenceFileResult = await SharedTools.getSystemInfo(updatedSystem.referenceNo, graphqlEndpoint, authorization);
        const refsystem = mapReferenceFileResultToSystemTestRow(referenceFileResult, updatedSystem);
        if (refsystem.status === SharedTypes.Status.Complete) {
            update(refsystem);
            return;
        }
        updatedSystem = Object.assign(Object.assign({}, refsystem), { status: SharedTypes.Status.FetchingTestSystem });
        update(updatedSystem);
        const testFileResult = await SharedTools.getSystemInfo(updatedSystem.testNo, graphqlEndpoint, authorization);
        const testSystem = mapTestFileResultToSystemTestRow(testFileResult, updatedSystem);
        if (testSystem.status === SharedTypes.Status.Complete) {
            update(testSystem);
            return;
        }
        updatedSystem = Object.assign(Object.assign({}, testSystem), { status: SharedTypes.Status.Comparing });
        update(updatedSystem);
        const compareResponse = await compareSystems(updatedSystem, graphqlEndpoint, authorization);
        const compare = buildSystemBasedOnResponse(compareResponse, updatedSystem, getFormat);
        updatedSystem = Object.assign(Object.assign({}, compare), { status: SharedTypes.Status.Complete });
    }
    catch (error) {
        console.log("in catch", updatedSystem);
        updatedSystem = Object.assign(Object.assign({}, updatedSystem), { status: SharedTypes.Status.Complete, result: {
                type: "error",
                errorText: "Unexpected error occured while " +
                    SharedTypes.Status[updatedSystem.status]
            } });
    }
    update(updatedSystem);
}
async function compareSystems(systemTestRow, graphqlEndpoint, authorization) {
    const compareResponse = await GraphQlRequest.request(queries_1.nevadaCompareSystems, {
        input: {
            referenceGenesysNo: systemTestRow.referenceNo,
            referenceRev: systemTestRow.referenceRev,
            testGenesysNo: systemTestRow.testNo,
            testRev: systemTestRow.testRev
        }
    }, false, graphqlEndpoint, authorization);
    return compareResponse;
}
function buildSystemBasedOnResponse(compareResponse, systemTestRow, getFormat) {
    if (compareResponse.user.systemCompare.hasError) {
        return Object.assign(Object.assign({}, systemTestRow), { result: {
                type: "error",
                errorText: compareResponse.user.systemCompare.errorText
            }, systemRowIsOk: false });
    }
    const systemCompare = compareResponse.user.systemCompare;
    const resultNodes = SharedTools.buildResultNodes(systemCompare.compareResult, getFormat);
    const ok = resultNodes.every(r => r.ok);
    return Object.assign(Object.assign({}, systemTestRow), { result: {
            type: "result",
            nodes: resultNodes,
            warnings: systemCompare.warnings || []
        }, systemRowIsOk: ok });
}
function mapReferenceFileResultToSystemTestRow(systemFileIdResult, systemTestRow) {
    if (!systemFileIdResult.user.genesysNumberToFile) {
        return Object.assign(Object.assign({}, systemTestRow), { status: SharedTypes.Status.Complete, result: {
                type: "error",
                errorText: "Reference system file not found or UnAuthorised"
            } });
    }
    if (!systemFileIdResult.user.genesysNumberToFile.systems
        .map(x => x.revisionNo)
        .includes(systemTestRow.referenceRev)) {
        return Object.assign(Object.assign({}, systemTestRow), { status: SharedTypes.Status.Complete, systemType: systemFileIdResult.user.genesysNumberToFile.systemTypeId, result: {
                type: "error",
                errorText: "Revision for reference system not found"
            } });
    }
    return Object.assign(Object.assign({}, systemTestRow), { systemType: systemFileIdResult.user.genesysNumberToFile.systemTypeId, name: "Testing " + systemFileIdResult.user.genesysNumberToFile.name });
}
function mapTestFileResultToSystemTestRow(systemFileIdResult, systemTestRow) {
    if (!systemFileIdResult.user.genesysNumberToFile.systems
        .map(x => x.revisionNo)
        .includes(systemTestRow.testRev)) {
        return Object.assign(Object.assign({}, systemTestRow), { status: SharedTypes.Status.Complete, systemType: systemFileIdResult.user.genesysNumberToFile.systemTypeId, result: {
                type: "error",
                errorText: "Revision for test system not found"
            } });
    }
    if (systemFileIdResult.user.genesysNumberToFile.systemTypeId !==
        systemTestRow.systemType) {
        return Object.assign(Object.assign({}, systemTestRow), { status: SharedTypes.Status.Complete, systemType: "", result: {
                type: "error",
                errorText: systemTestRow.systemType +
                    " and " +
                    systemFileIdResult.user.genesysNumberToFile.systemTypeId +
                    " are incompatible. System types have to be the same"
            } });
    }
    return Object.assign(Object.assign({}, systemTestRow), { name: systemTestRow.name +
            " with " +
            systemFileIdResult.user.genesysNumberToFile.name });
}
//# sourceMappingURL=run-request.js.map